import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  BarChart3,
  BookOpen,
  ChevronDown,
  Filter,
  LayoutDashboard,
  Users,
  X,
} from "lucide-react";
import RodapeInternal from "../rodape_internal";
import "../header.css";
import "../header_internal.css";
import "./admin.css";

const adminLinks = [
  { label: "Estatísticas", href: "/admin/stats", icon: <BarChart3 size={18} /> },
  { label: "Checkout", href: "/admin/checkout", icon: <Filter size={18} /> },
  { label: "Usuários", href: "/admin/users", icon: <Users size={18} /> },
  { label: "Conteúdo", href: "/admin/content", icon: <BookOpen size={18} /> },
];

function AdminHeader({ isMobile }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const header = document.querySelector(".header-internal");
    if (header) {
      if (menuOpen) header.classList.add("fixed-top");
      else header.classList.remove("fixed-top");
    }
  }, [menuOpen]);

  if (isMobile) {
    return (
      <header className="header header-internal">
        <div className="logo-container">
          <a href="/admin/stats" title="Admin Domínio Elétrico" className="logo-link">
            <img
              src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
              alt="Logo do Domínio Elétrico"
              className="logo"
            />
          </a>
        </div>
        <nav className="nav">
          <button
            onClick={() => setMenuOpen((prev) => !prev)}
            className="menu-button"
            aria-expanded={menuOpen}
          >
            <span className="menu-label">
              Admin {menuOpen ? <X size={22} /> : <ChevronDown size={22} />}
            </span>
          </button>
          {menuOpen && (
            <ul className="dropdown" role="menu">
              <div className="mobile-auth-buttons">
                <a href="/dashboard" className="auth-button mobile-auth-button">
                  <LayoutDashboard size={18} /> Área de alunos
                </a>
              </div>
              {adminLinks.map((link) => (
                <li key={link.href}>
                  <NavLink
                    to={link.href}
                    className="link internal-link"
                    role="menuitem"
                    onClick={() => setMenuOpen(false)}
                  >
                    {link.icon} {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </nav>
      </header>
    );
  }

  return (
    <header className="header header-desktop header-internal">
      <div className="logo-container">
        <a href="/admin/stats" title="Admin Domínio Elétrico" className="logo-link">
          <img
            src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
            alt="Logo do Domínio Elétrico"
            className="logo"
          />
        </a>
      </div>
      <nav className="nav public-nav header-internal-nav">
        {adminLinks.map((link) => (
          <NavLink
            key={link.href}
            to={link.href}
            className={({ isActive }) =>
              `menu-button-desktop internal-link${isActive ? " admin-nav-active" : ""}`
            }
          >
            {link.icon} {link.label}
          </NavLink>
        ))}
      </nav>
      <nav className="nav internal-nav">
        <a href="/dashboard" className="menu-button-desktop auth-button">
          <LayoutDashboard size={18} /> Área de alunos
        </a>
      </nav>
    </header>
  );
}

export default function AdminLayout() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return (
    <div className="admin-shell">
      <AdminHeader isMobile={isMobile} />
      <main className="admin-main">
        <Outlet />
      </main>
      <RodapeInternal />
    </div>
  );
}
